/* esm.sh - @noble/hashes@1.8.0/sha1 */
import{SHA1 as s,sha1 as o}from"@noble/hashes/legacy";var t=s,n=o;export{t as SHA1,n as sha1};
//# sourceMappingURL=sha1.mjs.map